// Beacon Counseling lighthouse mark — recreated as a crisp, scalable SVG.
// tone="dark"  -> for use on LIGHT backgrounds (navy tower)
// tone="light" -> for use on DARK backgrounds (soft-white tower)
export default function Logo({ className = "h-9 w-9", tone = "dark", id = "beacon" }) {
  const isLight = tone === "light";
  const tower = isLight ? "#EAF0F7" : "#0B1B33";
  const ring = isLight ? "rgba(255,255,255,0.45)" : "rgba(11,27,51,0.35)";
  const waveA = isLight ? "#9DC7C0" : "#5B7A85"; // slate/sage
  const waveB = "#2BB3A3"; // teal
  const beam = isLight ? "#F4D08A" : "#E8B85C"; // warm gold

  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Beacon Counseling lighthouse logo">
      <defs>
        <linearGradient id={`${id}-beamL`} x1="1" y1="0" x2="0" y2="0">
          <stop offset="0" stopColor={beam} stopOpacity="0.9" />
          <stop offset="1" stopColor={beam} stopOpacity="0" />
        </linearGradient>
        <linearGradient id={`${id}-beamR`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor={beam} stopOpacity="0.9" />
          <stop offset="1" stopColor={beam} stopOpacity="0" />
        </linearGradient>
        <linearGradient id={`${id}-glow`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FCE9BE" />
          <stop offset="1" stopColor={beam} />
        </linearGradient>
      </defs>

      {/* Ring */}
      <circle cx="24" cy="20.5" r="17.2" fill="none" stroke={ring} strokeWidth="1.3" />

      {/* Light beams */}
      <path d="M22 16 L4.5 11 L4.5 22 Z" fill={`url(#${id}-beamL)`} />
      <path d="M26 16 L43.5 11 L43.5 22 Z" fill={`url(#${id}-beamR)`} />

      {/* Finial + roof */}
      <circle cx="24" cy="12.4" r="0.8" fill={tower} />
      <path d="M20.9 16.4 L24 12.9 L27.1 16.4 Z" fill={tower} />

      {/* Lantern room (glowing) */}
      <rect x="22" y="16.2" width="4" height="4.6" rx="0.5" fill={tower} />
      <rect x="22.7" y="16.8" width="2.6" height="3.4" rx="0.3" fill={`url(#${id}-glow)`} />

      {/* Gallery platform */}
      <rect x="20.8" y="20.6" width="6.4" height="1.5" rx="0.5" fill={tower} />

      {/* Tower body */}
      <path d="M21 22.2 L27 22.2 L28.4 33 L19.6 33 Z" fill={tower} />

      {/* Base */}
      <rect x="18.8" y="32.6" width="10.4" height="1.7" rx="0.6" fill={tower} />

      {/* Waves */}
      <path d="M7 37.2 C13 34.6 18 34.6 24 36.6 C30 38.6 35 38.6 41 36 L41 38.4 C35 40.8 30 40.8 24 38.8 C18 36.8 13 36.8 7 39.4 Z" fill={waveA} opacity="0.85" />
      <path d="M8 39.4 C14 37 19 37 24 38.8 C29 40.6 34 40.6 40 38.2 L40 40.4 C34 42.6 29 42.6 24 40.8 C19 39 14 39 8 41.4 Z" fill={waveB} />
    </svg>
  );
}
